import {css} from 'lit';

import {defaultStyles} from '../../../components/modal.js';

export const styles = defaultStyles.extends({
  statics: css``,
});

export default {styles};
